export const MOTHER_BREAKPOINT = 1100
